/**
 * Created by Qingger Corp.
 * User: lilong
 * Date: 2020/04/19
 * Time: 13:56
 * Desc: 店铺展示管理之橱窗
 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import type { ElForm } from "element-ui/types/form";
import type { ElTree } from "element-ui/types/tree";
import NewSelectSite from "../newSelectSIte";
import { IPSService } from "@/services/ipsServices";
import bindClassDialog from "@/views/components/newDisplayConfig/bindClassDialog";
import { Functions } from "@/library/utils/functions";
import { defaultImg, defaultLogo } from "@/views/components/newDisplayConfig/shop";
import GoodsGroup from "@/views/components/goodsGroup";
import phoneStyle from "@/views/components/newDisplayConfig/style.vue";
import { QinggerLibUtils, noop } from "@/util";
const defaultBg = "https://ssl-picture.tenyun.runsasoft.com/54200870-8371-11ea-9b4f-ef6ec191275b";
const isset = QinggerLibUtils.isset;

@Component({
	mixins: [phoneStyle],
	components: {
		bindClassDialog,
		GoodsGroup,
	},
})
export default class ShopDisplayWindow extends Vue {
	/**
	 * 顶部标签是否禁用
	 * @type {boolean}
	 */
	@Prop({ default: false }) switchIsDisabled: boolean;

	@Prop({ default: {} })
	postParams: ItemObject;

	@Watch("postParams", { deep: true })
	watchPostParams() {
		this.page = this.postParams.page;
		this.pageSize = this.postParams.pageSize;
		this.keywords = this.postParams.keyword;
		if (this.postParams.parentId) {
			this.getWindowList();
		} else {
			this.windowList = [];
			this.totalCount = 0;
			this.page = 1;
			this.pageSize = 10;
			this.keywords = "";
			this.$emit("loadingClose");
		}
	}

	$refs: {
		ruleArr: ElForm;
		windowTree: ElTree<any, any>;
	};

	connectedClass = [];

	// 最多显示元素

	mostDisplay = 20;

	confirmBtnLoading = false;
	/**
	 * 橱窗标题关键字
	 * @type {string}
	 */
	public keywords = "";

	/**
	 * 橱窗列表
	 * @type {Array<ItemObject>}
	 */
	public windowList: Array<ItemObject> = [];

	/**
	 * 加载状态
	 * @type {boolean}
	 */
	public loadingState = false;

	/**
	 * 配置模块id
	 * @type
	 */
	public sgwpId = null;

	/**
	 * 橱窗总数
	 * @type {number}
	 */
	public totalCount = 0;

	/**
	 * 每页显示数量
	 * @type {number}
	 */
	public pageSize = 10;

	/**
	 * 当前页
	 * @type {number}
	 */
	public page = 1;

	/**
	 * 是否显示添加橱窗弹窗
	 * @type {boolean}
	 */
	public isShowEdit = false;

	/**
	 * 展示橱窗详情
	 * @type {boolean}
	 */
	public isShowWindowDetail = false;

	/**
	 * 橱窗详情
	 * @type {ItemObject}
	 */
	public windowDetail: ItemObject = {};

	/**
	 * 是否展示网点弹窗
	 * @type {boolean}
	 */
	public isShowChooseSiteDialog = false;

	/**
	 * 是否展示绑定商品列表主档分类
	 */
	public isShowBindingClassDialog = false;

	/**
	 *
	 */
	public selectProType: Array<ItemObject> = [];

	/**
	 * 橱窗名称
	 * @type {string}
	 */
	public windowName = "";

	/**
	 * 橱窗展示风格
	 * @type {number} 1 1行两列  2 横向滚动 3 大图 0 不展示
	 */
	public caseStyle = 0;

	/**
	 * @type {ItemObject}
	 */
	public defaultProps: ItemObject = {
		children: "pageList",
		label: (data, node) => {
			let result = "";
			if (data.sgName) {
				result = data.sgName;
			}
			if (data.sgwpName) {
				result = data.sgwpName;
			}
			return result;
		},
	};

	/**
	 * 网点控件是否只读
	 * @type {boolean}
	 */
	public isReadOnly = false;

	/**
	 * 网点控件标题
	 * @type {string}
	 */
	public title = "选择网点列表";

	/**
	 * 店铺列表
	 * @type {Array<ItemObject>}
	 */
	public shopList: Array<ItemObject> = [];

	/**
	 * 已选网点
	 * @type {Array<String>}
	 */
	public bindSelectedSiteList: Array<String> = [];

	/**
	 * 表单验证条件
	 * @type {ItemObject}
	 */
	public ruleArr: ItemObject = {
		windowTitle: [{ required: true, message: " " }],
		siteList: [{ required: true, message: " " }],
	};

	/**
	 * 追加橱窗策略表单
	 * @type {ItemObject}
	 */
	public editWindowForm = {
		caseId: 0,
		windowList: [],
		windowTitle: "",
		siteList: [],
		binding: 1,
		productType: [],
		productSort: 1,
		productCodes: "",
		sgmpId: 0,
		hasAddSiteCodes: [],
		// isDisplay: 1,
	};

	/**
	 * 商品分类
	 * @type {Array<ItemObject>}
	 */
	public productTypes: Array<ItemObject> = [];

	/**
	 * 是否禁用
	 * @type {boolean}
	 */
	public isDisabled = false;

	/**
	 * 中间示意图信息
	 * @type {ItemObject}
	 */
	public shopSketchMapInfo = {
		siteLogo: "",
		imageUrl: [],
		windowList: [],
	};

	date = [];

	public defaultStart: Date;

	public defaultEnd: Date;
	/**
	 * @type {ItemObject}
	 */
	public selectTypeToTitle = {
		Swiper: "店铺形象图",
		Site: "店铺信息",
		LabelClass: "分类导航",
		ShowWindow: "商品橱窗",
		Propagate: "广告位",
	};

	/**
	 * 获取关联分类
	 */
	public getAttributeList(): Promise<any> {
		return IPSService.getAttributeList().then((res) => {
			this.connectedClass = isset(res, "list") ? res.list : [];
		});
	}

	public mounted() {
		// this.getWindowList();
		this.getAttrTreeList();
		// this.getAttributeList();
	}

	onGoodsGroupChange(list: any[], isDisplay) {
		this.editWindowForm.productCodes = list.map((i) => i.productCode).join(",");
		// this.editWindowForm.isDisplay = isDisplay;
	}

	/**
	 * 切换页码
	 * @param {number} val
	 * @return null
	 */
	public onPageChange(val) {
		this.page = val;
		this.getWindowList();
	}

	/**
	 * 切换每页显示数量
	 * @param {number} val
	 * @return null
	 */
	public onSizeChange(val) {
		this.page = 1;
		this.pageSize = val;
		this.getWindowList();
	}

	/**
	 * @return null
	 */
	public onHandleSelectionChange() {}

	// 商城页数据
	shopData = [];

	attrTreeList = [];

	/**
	 * 监听isShowEdit
	 * @param val
	 */
	@Watch("isShowEdit")
	watchIsShowEdit(val) {
		if (!val) {
			this.isShowWindowDetail = false;
		}
	}

	/**
	 * 监听是否禁用
	 * @return null
	 */
	@Watch("switchIsDisabled", { deep: true, immediate: true })
	watchSwitchIsDisabled(val) {
		this.isDisabled = val;
	}

	/**
	 * 监听弹窗是否显示  初始化三个值
	 * @param val
	 */
	@Watch("isShowChooseSiteDialog")
	watchIsShowChooseSite(val) {
		if (!val) {
			this.isReadOnly = false;
			this.title = "选择网点";
		}
	}

	findWindowName(val) {
		const list = [];
		this.shopList.forEach((i) => {
			list.push(...i.pageList);
		});
		const find = list.find((v) => v.sgwpId === val.sgwpId);
		this.windowName = find ? find.sgwpName : "";
	}

	/**
	 * 编辑橱窗
	 * @return null
	 */
	public editShopWindow(val) {
		this.editWindowForm.caseId = val.caseId;
		this.isReadOnly = false;
		this.title = "选择网点列表";
		this.isShowEdit = true;
		this.findWindowName(val);
		IPSService.caseSiteCodes({ postParams: { sgwpId: this.postParams.sgwpId } }).then((res) => {
			this.exCodes = res.siteCodes;
		});
		IPSService.caseInfo({
			postParams: {
				caseId: val.caseId,
			},
		}).then((response) => {
			this.editWindowForm.windowTitle = response.caseName;
			this.editWindowForm.caseId = response.caseId;
			this.editWindowForm.binding = response.caseType;
			this.editWindowForm.siteList = val.siteCodes;
			this.bindSelectedSiteList = this.editWindowForm.siteList;
			this.editWindowForm.productType = response.vAttributeValues;
			this.editWindowForm.productSort = response.productSort || 1;
			this.editWindowForm.productCodes = response.productCodes;
			this.editWindowForm.sgmpId = response.sgmpId;
		});
	}

	/**
	 * 查看橱窗
	 * @param {number | string} item
	 * @return null
	 */
	public viewShopWindow(item) {
		this.editWindowForm.caseId = item.caseId;
		this.isReadOnly = true;
		this.title = "已选网点";

		this.findWindowName(item);

		IPSService.caseInfo({
			postParams: {
				caseId: item.caseId,
			},
		}).then((response) => {
			this.isShowWindowDetail = true;
			this.isShowEdit = true;
			this.editWindowForm.windowTitle = response.caseName;
			this.editWindowForm.caseId = response.caseId;
			this.editWindowForm.binding = response.caseType;
			this.editWindowForm.siteList = item.siteCodes;
			this.bindSelectedSiteList = this.editWindowForm.siteList;
			this.editWindowForm.productType = response.vAttributeValues;
			this.editWindowForm.productSort = response.productSort;
			this.editWindowForm.productCodes = response.productCodes;
			this.editWindowForm.sgmpId = response.sgmpId;
		});
	}

	/**
	 * 删除橱窗
	 * @param {string | number} item
	 * @return null
	 */
	public delShopWindow(item) {
		this.$confirm("确认删除？", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			closeOnClickModal: false,
			type: "warning",
		}).then(() => {
			IPSService.caseDelete({
				postParams: {
					caseId: item.caseId,
				},
			}).then((result) => {
				if (result.result) {
					this.$message.success("删除成功");
					this.page = 1;
					this.getWindowList();
				} else {
					this.$message.error("删除失败");
				}
			});
		});
	}

	public getAttrTreeList() {
		IPSService.getAttrTreeList().then((response) => {
			this.attrTreeList = response.list.map((v) => {
				v.value_no = v.attrCode;
				v.class_code = v.attrCode;
				v.value_name = v.attrName;
				return v;
			});
		});
	}

	getClassList(val = [], result = []) {
		val.forEach((v) => {
			result.push({
				value_no: v.value_no,
				value_name: v.value_name,
			});
			if (v.list) {
				this.getClassList(v.list, result);
			}
		});
		return result;
	}

	handleSearch() {
		if (this.postParams.parentId) {
			this.getWindowList();
		}
	}

	/**
	 * 获取橱窗列表
	 * @param {null}
	 * @return null
	 */
	public getWindowList() {
		const postParams = { sgId: this.postParams.sgId, sgwpId: this.postParams.sgwpId, keyword: this.keywords, page: this.page, pageSize: this.pageSize, pageId: this.postParams.pageId || 0 };
		IPSService.gsCaseList({
			postParams,
		})
			.then((response) => {
				this.windowList = response.list;
				this.windowList.forEach((item) => {
					item.time = Functions.timeFormat(item.updateTime);
					item.sites = item.siteCodes ? item.siteCodes.toString() : "";
				});
				this.totalCount = response.count;
				this.$emit("loadingClose");
			})
			.catch((error) => {
				this.$emit("loadingClose");
			});
	}
	exCodes = [];
	/**
	 * 追加橱窗策略
	 * @return null
	 */
	public addWindow() {
		this.editWindowForm.caseId = 0;
		this.editWindowForm.siteList = [];
		this.isShowEdit = true;
		this.isReadOnly = false;
		this.bindSelectedSiteList = this.editWindowForm.siteList;
		IPSService.caseSiteCodes({ postParams: { sgwpId: this.postParams.sgwpId } }).then((res) => {
			this.exCodes = res.siteCodes;
		});
	}

	/**
	 * 关闭追加橱窗策略弹窗
	 * @return null
	 */
	public closeEditWindow() {
		this.editWindowForm = {
			caseId: 0,
			windowList: [],
			windowTitle: "",
			siteList: [],
			binding: 1,
			productType: [],
			productSort: 1,
			productCodes: "",
			sgmpId: 0,
			hasAddSiteCodes: [],
			// isDisplay: 1,
		};
		this.isShowEdit = false;
	}

	/**
	 * 确认追加橱窗策略弹窗
	 * @return null
	 */
	public confirmEditWindow(ruleArr) {
		this.$refs.ruleArr.validate((result) => {
			if (result) {
				this.confirmBtnLoading = true;
				const postParams: any = {
					caseId: this.editWindowForm.caseId,
					sgId: this.postParams.sgId,
					sgwpId: this.postParams.sgwpId,
					caseName: this.editWindowForm.windowTitle,
					siteCodes: this.bindSelectedSiteList,
					caseType: this.editWindowForm.binding,
					pageId: this.postParams.pageId || 0,
					sgmpId: this.postParams.sgwpId,
				};
				if (this.editWindowForm.binding === 1) {
					postParams["vAttributeValues"] = this.editWindowForm.productType;
					postParams["productSort"] = this.editWindowForm.productSort;
				}
				if (this.editWindowForm.binding === 3) {
					postParams["productCodes"] = this.editWindowForm.productCodes;
					// postParams["isDisplay"] = this.editWindowForm.isDisplay;
				}

				IPSService.caseEdit({ postParams }).then(
					(response) => {
						this.$message.success("保存成功");
						this.closeEditWindow();
						this.getWindowList();
						this.confirmBtnLoading = false;
					},
					() => {
						this.confirmBtnLoading = false;
					},
				);
			}
		});
	}

	/**
	 * 选择商品主档分类
	 */
	public onSelectProType() {
		if (!this.isShowWindowDetail) {
			const defaultCheckedKeys = this.editWindowForm.productType.flatMap((v) => v.attrValues.split(","));
			bindClassDialog.open({ defaultCheckedKeys }).then((res) => {
				const result = res.filter((v) => v.isLeafe);
				const parentCodes = [...new Set(result.map((v) => v.class_code))];
				this.editWindowForm.productType = parentCodes.map((v) => {
					const attrValues = result
						.filter((val) => {
							return val.class_code === v;
						})
						.map((val) => val.value_no)
						.join(",");
					return {
						attrCode: v,
						attrValues,
					};
				});
			}, noop);
		}
	}

	/**
	 * 计算选择商品列表显示文字
	 * @return string
	 */
	public getSelectTypeName(item) {
		let result = "";
		let index = -1;
		this.attrTreeList.forEach((v, i) => {
			if (v.attrCode === item.attrCode) {
				result = `${v.attrName}-`;
				index = i;
			}
		});
		const classList = this.getClassList(this.attrTreeList[index] ? this.attrTreeList[index].list : [] || [], []);
		const childrenClass = item.attrValues ? item.attrValues.split(",") : [];
		return (
			result +
			childrenClass
				.map((v) => {
					let value_name = "";
					classList.forEach((val) => {
						if (val.value_no === v) {
							value_name = val.value_name;
						}
					});
					return value_name;
				})
				.filter((v) => !!v)
				.join(",")
		);
	}

	/**
	 * 移除选择分类
	 * @return null
	 */
	public handleDeleteSelect(index) {
		this.editWindowForm.productType.splice(index, 1);
	}

	/**
	 * 查看已选网点
	 * @return {null}
	 */
	public viewSite(val) {
		new NewSelectSite()
			.open({
				sgId: this.postParams.sgId,
				param: {
					sgwpId: this.postParams.sgwpId,
					caseId: val.caseId,
				},
				// service: 'case',
				exArr: val.hasAddSiteCodes.concat(this.exCodes) || [],
				selectCodes: val.siteCodes,
				readonly: true,
			})
			.then(noop, noop);
	}

	getShopData(sgId) {
		return IPSService.decorationMallInfo({ postParams: { sgId } }).then((res: any) => {
			const list = res.list
				.map((v, i) => {
					// 添加网点的默认图片
					if (v.fieldType === "Site" && !(v as NewDisplayShopInfo).desc.siteInfo.siteLogo) {
						(v as NewDisplayShopInfo).desc.siteInfo.siteLogo = defaultLogo;
					}
					if (v.fieldType === "Swiper" && !(v as NewDisplayShopBg).desc.imageUrl) {
						(v as NewDisplayShopBg).desc.imageUrl = defaultBg;
					}
					if (i.fieldType === "LabelClass") {
						(i as any).desc.map((i) => {
							i.classPic = defaultImg;
							return i;
						});
					}
					v._active = false;
					v._sort = i;
					return v;
				})
				.filter((i) => {
					return Object.keys(this.selectTypeToTitle).includes(i.fieldType);
				});

			return list;
		});
	}

	openSelectSiteDialog(readonly) {
		new NewSelectSite()
			.open({
				sgId: this.postParams.sgId,
				param: {
					sgwpId: this.postParams.sgwpId,
					caseId: this.editWindowForm.caseId,
				},
				service: "case",
				exArr: this.editWindowForm.hasAddSiteCodes || [],
				selectCodes: this.editWindowForm.siteList.map((i) => {
					return typeof i !== "string" ? i.siteCode : i;
				}),
				readonly,
			})
			.then((val) => {
				this.bindSelectedSiteList = val;
				this.editWindowForm.siteList = val;
			}, noop);
	}

	/**
	 * 接收确认选择网点
	 */
	public confirmSelect(val) {
		this.bindSelectedSiteList = val;
		this.editWindowForm.siteList = val;
	}
}
